import { render, staticRenderFns } from "./init.vue?vue&type=template&id=bca09bd6&scoped=true&"
import script from "./init.vue?vue&type=script&lang=js&"
export * from "./init.vue?vue&type=script&lang=js&"
import style0 from "./init.vue?vue&type=style&index=0&id=bca09bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca09bd6",
  null
  
)

export default component.exports